// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADMIN_USER = "Modr\u00fd kon\u00edk";
